export interface Place {
  id: string;
  name: string;
  description: string;
  logoUrl: string;
  coverImageUrl: string;
  instagram: string;
  address: string;
  cityId: string;
  cityName: string;
  stateId: string;
  stateName: string;
  products: Product[];
  reviewCount: number;
  createdAt: string;
  updatedAt?: string;
}

export interface Product {
  id: string;
  name: string;
  description?: string;
  originalPrice: number;
  discountedPrice?: number;
  discountPercentage: number;
  category: string;
  isAvailable: boolean;
  isRequiredProduct: boolean;
  isBlocked: boolean;
  hasTimeRestriction: boolean;
  availableFrom?: string;
  availableTo?: string;
  imageUrl?: string;
  usageFrequency: UsageFrequency;
  placeId: string;
  createdAt: string;
  updatedAt?: string;
}

export enum UsageFrequency {
  Unlimited = 'Unlimited',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Biweekly = 'Biweekly',
  Monthly = 'Monthly'
}

export interface CreatePlaceRequest {
  name: string;
  description: string;
  logoUrl: string;
  coverImageUrl: string;
  instagram: string;
  address: string;
  cityId: string;
}

export interface UpdatePlaceRequest {
  name?: string;
  description?: string;
  logoUrl?: string;
  coverImageUrl?: string;
  instagram?: string;
  address?: string;
  cityId?: string;
}

export interface CreateProductRequest {
  name: string;
  originalPrice: number;
  discountPercentage: number;
}

export interface UpdateProductRequest {
  name?: string;
  originalPrice?: number;
  discountPercentage?: number;
}

export interface PlaceStats {
  totalFavorites: number;
  totalVisited: number;
  totalSaved: number;
  totalReviews: number;
  averageRating: number;
  totalProducts: number;
  monthlyVisitors: number;
  monthlyRevenue: number;
}

export interface PlaceAdmin {
  id: string;
  userId: string;
  placeId: string;
  role: 'owner' | 'admin' | 'manager';
  createdAt: string;
  user: {
    id: string;
    fullName: string;
    email: string;
  };
} 